<template>
  <div>
    <v-progress-linear v-if="carregando" indeterminate />
    <v-container v-else-if="resultado || erro" class="resultado-instituicoes">
      <h1>Resultados do Selo</h1><p>{{ uf }} · Ciclo 2026</p>
      <v-alert v-if="erro" type="info" outlined>{{ erro }}</v-alert>
      <p v-if="resultado && !salas.length && !erro">Nenhuma instituição disponível para seu acesso neste ciclo.</p>
      <v-btn v-if="administrador" outlined color="primary" to="/painel-recursos" class="mb-4">Recursos do Estado</v-btn>
      <v-card v-for="sala in salas" :key="sala.municipioId" outlined class="pa-4 mb-4">
        <h2>{{ sala.nome }}</h2>
        <p v-if="sala.podeVerResultado">{{ numero(sala.pontuacao) }} pontos · {{ sala.categoria }}</p>
        <p v-if="sala.mensagem">{{ sala.mensagem }}</p>
        <v-btn v-if="sala.podeEmitirRelatorio" color="primary" outlined :to="relatorio(sala)">Relatório final</v-btn>
        <v-btn v-if="sala.podeVerResultado" text :to="`/cidade/${sala.municipioId}/recursos`">Recursos</v-btn>
      </v-card>
    </v-container>
    <legacy-list v-else />
  </div>
</template>
<script>
import LegacyList from './List.vue';
import { atualUfDefinition } from '@/helpers/utils';
import { seloFechamentoAPI } from '@/modules/selo-fechamento/API/SeloFechamentoAPI';
import { normalizarDados, numero, mensagemErro } from '@/modules/selo-fechamento/utils';
export default {
  name: 'SeloClosingCityList', components: { LegacyList },
  data() { return { carregando: true, resultado: false, administrador: false, salas: [], erro: '' }; },
  computed: { uf() { return atualUfDefinition.uf; } },
  async mounted() {
    const config=JSON.parse(localStorage.getItem('config') || '{}');
    try {
      if (atualUfDefinition.isSala && config.fechamentoSelo && !this.$store.getters.isFullAdmin) {
        const estado=normalizarDados((await seloFechamentoAPI.estado(this.uf,2026)).data);
        if (estado.etapa >= 5 && !['NACIONAL','GESTOR_FECHAMENTO','CLIENTE_OCULTO'].includes(estado.papel)) {
          this.resultado=true; this.administrador=['ADMIN_UF','ADMIN_UF_PRINCIPAL'].includes(estado.papel);
          this.salas=normalizarDados((await seloFechamentoAPI.municipios(this.uf,2026)).data);
        }
      }
    } catch(error) { this.erro=mensagemErro(error); }
    finally { this.carregando=false; }
  },
  methods: { numero, relatorio(sala) { return { name: 'selo-relatorio-final', params: { uf: this.uf, ano: '2026', municipioId: String(sala.municipioId) }, query: { origem: 'sala' } }; } },
};
</script>
<style scoped>.resultado-instituicoes{max-width:1150px;padding:28px}h1{font-size:28px}h2{font-size:19px;margin-bottom:12px}</style>
